export async function executeAiProposal(ai, proposalInput, approvalReason) {
    const created = await ai.createProposal(proposalInput);
    const proposalDocumentId = created?.proposal?.documentId;
    if (!proposalDocumentId) throw new Error("ai.error.invalid_proposal");

    const validation = await ai.validateProposal(proposalDocumentId);
    if (validation?.valid === false) {
        const invalidOperation = validation.operations?.find((operation) => !operation.valid);
        const error = new Error(invalidOperation?.code || "ai.error.invalid_proposal");
        error.code = invalidOperation?.code || "ai.error.invalid_proposal";
        error.details = {operations: validation.operations || []};
        throw error;
    }
    await ai.submitProposal(proposalDocumentId);
    try {
        await ai.approveProposal(proposalDocumentId, {reason: approvalReason});
    } catch (error) {
        if (
            error?.status === 403
            || error?.code === "AI_FORBIDDEN"
            || error?.code === "ai.error.permission_denied"
        ) {
            return {status: "submitted", proposalDocumentId};
        }
        throw error;
    }

    const result = await ai.executeProposal(proposalDocumentId, `ai-execution:${proposalDocumentId}`);
    return {status: "executed", proposalDocumentId, result};
}
